import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

const Image = () => {
  return <StaticImage src={'../images/l'} alt={'Gatsby Icon'} />
}

export default Image
